"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Gear = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Gear"));

// Generated by script, don't edit it please.
var Gear = (0, _createSvgIcon["default"])({
  as: _Gear["default"],
  ariaLabel: 'gear',
  category: 'action',
  displayName: 'Gear'
});
var _default = Gear;
exports["default"] = _default;
module.exports = exports.default;